export default __webpack_public_path__ + "static/media/brassart_of_vicious_frenzy.d300ac50.jpg";